export default {
    baseApiUrl: process.env.REACT_APP_API_URL,
    imageUploadFolder: process.env.REACT_APP_PUBLIC_UPLOAD_IMAGE_FOLDER,
    pdfUploadFolder: process.env.REACT_APP_PUBLIC_UPLOAD_PDF_FOLDER,
};
  